import { render, staticRenderFns } from "./ShowInfoDelegator.vue?vue&type=template&id=01619eec"
import script from "./ShowInfoDelegator.vue?vue&type=script&lang=js"
export * from "./ShowInfoDelegator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports